import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";

export const HeroSwiper = styled(Swiper)``;

export const HeroSwiperSlide = styled(SwiperSlide)`
  min-height: 736px;
`;
